//import * as jQuery from "jquery";
import "angular/angular";
import "angular-sanitize/angular-sanitize";
import "angular-resource/angular-resource";
import "angular-filter/dist/angular-filter";
import "re-tree/re-tree";
import "ua-device-detector/ua-device-detector";
import "ng-device-detector/ng-device-detector";
import "ng-dialog/js/ngDialog";
import "./Libs/tooltip";
import "./Libs/tooltip.slide";
import "./Libs/md5";
import "./Services/alertService";
import "./Services/downloadService";
import "./Services/documentService";
import "./Directives/directives";
import "./Directives/typeahead";
import "./initApp";

var helpme = {};

(function () {
    "use strict";

    var app = angular.module('downloadCenterApp');

    app.constant('transl', {
        files: bm.translations.dlcFiles,
        acceptLicense: bm.translations.dlcAcceptLicense,
        close: bm.translations.close
    });

    app.constant('preselectedProduct', bm.defaults.preselected);

    switch (bm.defaults.system) {
        case 'KonicaMinolta':
            app.constant('tooltipIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARBAMAAADJQ1rJAAAAJ1BMVEUAZswAZswAZswAAAAAZsz////6/P6Ftuc1htcEaM261vGix+w9i9h9gNk0AAAABHRSTlP2uTAABVfcjQAAAFJJREFUCNdjMBJwAQIHIQMGBSANYiowiLi4eE4BMgUYWFxcyrKBLAYGIFEWBZJmAKuCsUJDYayjcJYrXlZraAtcbwiIxQI1jwFoLwQIINyCcB8ASBcnnSLEZFgAAAAASUVORK5CYII=');
            app.constant('descriptionIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAANlBMVEUAZswAZswAAAAAZswAZswAZswAZswAZsz///8QcM/o8fo9i9gYdNHD2/PC2vNyquNxquNent+liaXJAAAAB3RSTlOPgADtYxA8PqPm0QAAAGJJREFUGNOFkIsKwCAIRW+W5aq9/v9n1yZUi8YOCHJQwQsidqbimAjkbeiwnsBqmmO4MOBgtBGRRTt8qV2Uo5tKsYiYXot5lS23ReUs1Ss9LX9KqWoAk4cmb0/CeSJE5Y7wAjSCB7W7hdENAAAAAElFTkSuQmCC');
            break;
        case 'Develop':
            app.constant('tooltipIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAYdEVYdENyZWF0aW9uIFRpbWUAMjkuMDUuMjAxM8CfYIoAAAFYSURBVDiNrZS/TsJQFIe/e0t6y5+Ore3AIzC4ujAYJzdXBxNHE1/JR/AFmHgBBxInBweG1jJBC/QS2joUCaHVIPDbTs65X37n5J4jiqIo2NN8PidJEpbLJessA6BhGDSbTTqdDu12e/8JYhektWYymZBqXSnclaUUjuOglKqCFosF4VdInlcM1kpKgXfh0Wq1yhgg1ZogDCoQMZ1h3j9hPjxXQHleEIQBeuNeAkyiiOqkQHx8IkbviLcR1LRbFBBFUVmbJEkRhOFB7fwm3/OQcRzXJo3BEPPyGtXro3r9P0FxHCPTNK1NZjd91q8vBzlK0xT5809O0TrLymGfQ7JhGCdDGoaBtCzrZJBlWUjbtmuTxmBI4+5xG5tXt4jprLbWtu1yRcbjMXq1OsqNMk263W45bMd1EeL/ECHAdV1gsyKWUviej5SH06QU+J6/vQDnPyO7OuawfQNkypum27mMOwAAAABJRU5ErkJggg==');
            app.constant('descriptionIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABh0RVh0Q3JlYXRpb24gVGltZQAwNS4xMi4yMDEzmSx4rwAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAADLSURBVDiNzZPdDYIwFIU/ja8mbd9wAAcQx9A1XAMcQ9aANXQAhmibuIAPUgN4uf7EB0/SpBxOvhxuC/xAs7QxzlbARsk20YdSerEQvIvgrYGdcfYcfahfQqIPh7HXa1kYZxmD5nJzVYVxdv8NpAaqbgEMINJMHjLO5sCgvnH26XNVCFACGbDVQiIkNQCuQNZ7bqX81ExWwIn70dLt8+jD9W1IN4Njz2qiD5WU1ZokUAO0Uzc1SR1s9KE0zi61jAjpbufY+wyC/hP+uW6vtDkcxVYRRwAAAABJRU5ErkJggg==');
            break;
        case 'Olivetti':
            app.constant('tooltipIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QMGDS06nflXhQAAAM9JREFUOMu1kz8KgzAchT/TdugJnFyyOHRoZ1GKqxfxCB6gk1cqghShs1PAwdBeoh3bJRSkmvqHPsjwSPLxfiHPASilPAA5EAFbfusJVEAWa107BnAdebkPFgiToBcgzLJoC+TCjPClXZoSKkWoFPvTyQaKxK8xnNWKjeta0zillC8Waj20cWyajr/4/iBk8N1uSTI6ySDk3rbLIVP0X4jneVY/CiKLwuo7f6mU8jGzN5/+CNPGJaoEkJk2MrPFmYi1roEAOE+APc35INa6fgOzjy/+iFl6XAAAAABJRU5ErkJggg==');
            app.constant('descriptionIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QMGDS4motVYCQAAAQdJREFUOMutlD2LwkAQhp9Ef4Ba2QQEWwWxCuHAIlhbmM6/mBTWhxDFWgQFbQ4CA7Jp7iwtDNisktxdJMa81bIfD+/M7IyB1me73QCmgEUxCRCMlToDGBryAcyBFq/pG5iMlVob2slXCUga1jV1OGUh6LfT+rOcuCKP9abT4SdJ8q72TCrSH9DA83BFMm4AhlGEK8LA84qBtr7PyXFI4jizn8QxJ8dh6/vFQAAHEY62zWW1AuAShhxtm8Mvl2nV8w7U9YqazeiPRuyWy9dzdK9Ws1YDyEDcJ44qq1puaMMoeh+0sKxS/0gqiGxvAoFuPN5o2sDU82RSEnYfI2fjn8HWKxpOerDdAADPXaqMuCj5AAAAAElFTkSuQmCC');
            break;
        case 'Healthcare':
            app.constant('tooltipIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARBAMAAADJQ1rJAAAAJ1BMVEUAZswAZswAZswAAAAAZsz////6/P6Ftuc1htcEaM261vGix+w9i9h9gNk0AAAABHRSTlP2uTAABVfcjQAAAFJJREFUCNdjMBJwAQIHIQMGBSANYiowiLi4eE4BMgUYWFxcyrKBLAYGIFEWBZJmAKuCsUJDYayjcJYrXlZraAtcbwiIxQI1jwFoLwQIINyCcB8ASBcnnSLEZFgAAAAASUVORK5CYII=');
            app.constant('descriptionIcon', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAANlBMVEUAZswAZswAAAAAZswAZswAZswAZswAZsz///8QcM/o8fo9i9gYdNHD2/PC2vNyquNxquNent+liaXJAAAAB3RSTlOPgADtYxA8PqPm0QAAAGJJREFUGNOFkIsKwCAIRW+W5aq9/v9n1yZUi8YOCHJQwQsidqbimAjkbeiwnsBqmmO4MOBgtBGRRTt8qV2Uo5tKsYiYXot5lS23ReUs1Ss9LX9KqWoAk4cmb0/CeSJE5Y7wAjSCB7W7hdENAAAAAElFTkSuQmCC');
            break;
    }

    app.filter('tsToLocaleString', function () {
        return function (timestamp, format) {
            var date = new Date(timestamp * 1000),
                options = {
                    weekday: format === 'short' ? undefined : 'long',
                    year: 'numeric',
                    month: format === 'short' ? 'numeric' : 'long',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: '2-digit'
                };
            return date.toLocaleString('de-DE', options);
        };
    });

    app.filter('getSystems', function () {
        return function (items, language) {
            var result = [];
            angular.forEach(items, function (item) {
                if (item === language) {
                    result = item.systems;
                }
            });
            return result;
        };
    });

    app.filter('showAllOrIsFirst', function () {
        return function (documents, showAll) {
            var result = [];
            angular.forEach(documents, function (document) {
                if (showAll || document.isFirst) {
                    result.push(document);
                }
            });
            return result;
        }
    });

    app.filter('nl2br', ['$sce', function ($sce) {
        return function (text) {
            text = (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
            return $sce.trustAsHtml(text);
        };
    }]);

    app.controller('DownloadCenterController', [
        '$scope', '$timeout', 'DownloadService', 'AlertService', 'DocumentService', 'deviceDetector', 'ngDialog', 'transl', 'preselectedProduct', 'tooltipIcon', 'descriptionIcon',
        function ($scope, $timeout, DownloadService, AlertService, DocumentService, deviceDetector, ngDialog, transl, preselectedProduct, tooltipIcon, descriptionIcon) {
            helpme = $scope;

            $scope.tooltipIcon = tooltipIcon;
            $scope.descriptionIcon = descriptionIcon;
            $scope.Md5 = document.Md5;

            var restoreStatus = function (type, cache) {
                    var what = type === 'product' ? 'products' : 'productCategories';
                    if (cache) {
                        return function () {
                            var i, max, values = $scope[what];
                            for (i = 0, max = values.length; i < max; i++) {
                                if (values[i].AnacondaId_textS === cache.AnacondaId_textS) {
                                    $scope.selected[type] = values[i];
                                    return;
                                }
                            }
                            // not found
                            $scope.selected[type] = {};
                            if (type === 'product') {
                                $scope.changeProduct();
                                $scope.selected.productText = $scope.search = '';
                            }
                        };
                    } else {
                        return null;
                    }
                },
                initProduct = function () {
                    $scope.structuredDocuments = {};
                    $scope.documents = {};
                    $scope.selected.drivers = {
                        language: {},
                        os: {},
                        sortBy: null
                    };
                    $scope.selected.manuals = {
                        language: {},
                        sortBy: null
                    };
                    $scope.selected.applications= {
                        language: {},
                        os: {},
                        sortBy: null
                    };
                    $scope.selected.firmware = {
                        language: {},
                        sortBy: null
                    };
                    $scope.selected.safetyDocuments = {
                        language: {},
                        sortBy: null
                    };
                    $scope.selected.os = null;
                },
                translations = {},
                alertService = AlertService;
            alertService.add(['info', 'warning']);
            alertService.setTimeout(4000);
            $scope.message = alertService.message;

            $scope.preselectedProduct = preselectedProduct;
            $scope.downloadService = DownloadService;
            $scope.productCategories = [];
            $scope.products = [];
            $scope.eulas = {};
            $scope.selected = {
                product: null,
                productText: '',
                productCategory: null,
                legacy: false
            };
            initProduct();
            $scope.documentConcordance = {};
            $scope.FormData = {};
            DownloadService.init(function (data) {
                $scope.productNames = data.map(function (item) { return { label: item.Product_textS }; });
                $scope.$broadcast('stopSpinner');
            });

            $scope.displayDlcTop = function () {
                return preselectedProduct === '' || preselectedProduct === '0' || preselectedProduct !== parseInt(preselectedProduct, 10).toString();
            };

            $scope.changeLegacy = function () {
                $scope.$broadcast('startSpinner');

                // reload categories and products
                var selected = $scope.selected,
                    restoreStatusForProduct = restoreStatus('product', selected.product),
                    restoreStatusForProductCategory = restoreStatus('productCategory', selected.productCategory);
                DownloadService.getProductCategories(selected.legacy, restoreStatusForProductCategory);
                DownloadService.getProducts(selected.legacy, selected.productCategory, function () {
                    if (restoreStatusForProduct) {
                        restoreStatusForProduct();
                    }
                    $scope.$broadcast('stopSpinner');
                });
            };
            $scope.changeProductCategory = function () {
                // reload products for category
                var selected = $scope.selected,
                    restoreStatusForProduct = restoreStatus('product', selected.product);
                $scope.$broadcast('startSpinner');
                DownloadService.getProducts(selected.legacy, selected.productCategory, function () {
                    if (restoreStatusForProduct) {
                        restoreStatusForProduct();
                    }
                    $scope.$broadcast('stopSpinner');
                });
            };
            $scope.changeProduct = function () {
                initProduct();
                // select appropriate category
                // (but only if a product is actually selected)
                if (!$scope.selected.product) {
                    return;
                }
                $scope.$broadcast('startSpinner');

                var selected = $scope.selected,
                    productCategoryId = selected.product.ProductCategoryId_textS,
                    i, max, productCategories = $scope.productCategories;

                selected.productText = selected.product.Product_textS;
                jQuery('#dlc-product div input').val(selected.productText);

                for (i = 0, max = productCategories.length; i < max; i++) {
                    if (productCategories[i].AnacondaId_textS === productCategoryId) {
                        selected.productCategory = productCategories[i];
                        return $scope.getDocuments();
                    }
                }
                $scope.$broadcast('stopSpinner');
            };
            $scope.setProduct = function (item, level) {
                level = level || 0;

                if (angular.isObject(item)) {
                    $scope.selected.productText = item.label;
                }

                $scope.$broadcast('startSpinner');

                var selected = $scope.selected,
                    name = selected.productText,
                    products = $scope.products,
                    i, max;

                if (name === '') {
                    selected.products = null;
                    return;
                }

                for (i = 0, max = products.length; i < max; i++) {
                    if (products[i].Product_textS.toLowerCase() === name.toLowerCase()) {
                        selected.product = products[i];
                        if (level === 2) {
                            // we're in legacy mode (level==2) and found an result, so set
                            // legacy switch in gui to true
                            $scope.selected.legacy = true;
                        }
                        $scope.changeProduct();
                        return;
                    }
                }
                if (level < 2) {
                    // we might be stuck in category or non legacy mode, so recall this method
                    // 1) without categories
                    // 2) with legacy switched on
                    DownloadService.getProducts(!!level, null, function () {
                        $scope.setProduct(null, level+1);
                    });
                    return;
                }
                selected.products = null;
                $scope.$broadcast('stopSpinner');
            };
            $scope.getDocuments = function () {
                $scope.$broadcast('startSpinner');

                // get documents for product
                var selected = $scope.selected;
                if (!selected.product) {
                    return;
                }
                DownloadService.getDocuments(selected.product.AnacondaId_textS, function () { $scope.$broadcast('stopSpinner'); });
            };
            $scope.showNgDialog = function (document) {
                let baseUrl = window.location.protocol + "//" + window.location.host,
                    cses = document.CsesId_textS,
                    files = document.DownloadFiles_textS.split(/\n/),
                    fileList = files.map(function (file) {
                        let parts = file.split('|'),
                            md5hash = $scope.Md5.hex_md5(parts[2]),
                            documentId = document.AnacondaId_textS,
                            system = document.AnacondaSystem_textS,
                            language = document.UiLanguage_textS,
                            link = '?tx_kmdownloadproxy_downloadproxy[fileId]=' + md5hash
                                + '&tx_kmdownloadproxy_downloadproxy[documentId]=' + documentId
                                + '&tx_kmdownloadproxy_downloadproxy[system]=' + system
                                + '&tx_kmdownloadproxy_downloadproxy[language]=' + language
                                + '&type=' + '1558521685';

                        return {
                            piwikUrl: baseUrl + '/' + bm.defaults.languageCode + '/download-center/' + $scope.selected.product.Product_textS + '/' + cses + '/' + parts[0],
                            downloadUrl: link,
                            text: decodeURIComponent(parts[0]) + ' (' + parts[1] + 'KB)'
                        };
                    });

                $scope.title = document.Name_textS;
                $scope.eula = $scope.eulas[document.EulaId_textS];
                $scope.acceptLicenseText = transl.acceptLicense;
                $scope.filesText = transl.files;
                $scope.fileList = fileList;
                $scope.closeText = transl.close;
                ngDialog.open({
                    template: require('./Templates/downloadModal.html').default,
                    plain: true,
                    appendClassName: 'modal-download',
                    scope: $scope
                });
            };

            $scope.toggleEula = function () {
                let links = jQuery(".download-links").find("a"),
                    checkbox = jQuery("#check-eula");

                if (checkbox.is(":checked")) {
                    links.removeClass('disable-download');
                } else {
                    links.addClass('disable-download');
                }
            }

            $scope.trackPiwikDownload = function (filePath) {
                if (typeof piwikTracker !== "undefined") {
                    piwikTracker.trackLink(filePath, "download");
                }
            }

            $scope.$on('ngRepeatFinished', function () {
                $scope.$broadcast('stopSpinner');
            });

            $scope.$on('stopSpinner', function () {
                jQuery('#loading-animation').hide();
            });

            $scope.$on('startSpinner', function () {
                jQuery('#loading-animation').show();
            });

            $scope.$on('updateDocumentHeight', function () {
                // Send updated document height to parent window (used for referencing this page via iframe)
                var body = document.body,
                    html = document.documentElement;

                var height = Math.max(body.scrollHeight, body.offsetHeight, html.offsetHeight);

                window.parent.postMessage(height, '*');
            });

            $scope.$on('downloadService:getTranslations:success', function (_, data, callback) {
                translations = data;
                if (data.length === 0) {
                    $scope.$broadcast('stopSpinner');
                    $scope.message.warning = 'Sorry.  An unknown error occured loading translations.';
                }
                if (angular.isFunction(callback)) {
                    callback();
                }
            });
            $scope.$on('downloadService:getTranslations:error', function (_, data) {
                $scope.message.warning = 'Sorry.  An unknown error occured loading translations.';
                $scope.$broadcast('stopSpinner');
            });
            $scope.$on('downloadService:getProductCategories:success', function (_, data, callback) {
                $scope.productCategories = data;
                if (data.length === 0) {
                    $scope.$broadcast('stopSpinner');
                    $scope.message.warning = 'Sorry.  An unknown error occured.';
                } else {
                    if (angular.isFunction(callback)) {
                        callback();
                    }
                }
            });
            $scope.$on('downloadService:getProductCategories:error', function (_, data) {
                $scope.message.warning = 'Sorry.  An unknown error occured.';
                $scope.$broadcast('stopSpinner');
            });
            $scope.$on('downloadService:getProducts:success', function (_, data, callback) {
                var product = false;
                $scope.products = data;

                if (preselectedProduct !== '' && preselectedProduct !== '0') {
                    for (var i = 0, max = data.length; i < max; i++) {
                        if (data[i].AnacondaId_textS === preselectedProduct || data[i].Product_textS === preselectedProduct) {
                            product = data[i];
                            break;
                        }
                    }
                    if (product !== null) {
                        $scope.selected.product = product;
                        $scope.changeProduct();
                    }
                }
                if (angular.isFunction(callback)) {
                    callback();
                }
            });
            $scope.$on('downloadService:getProducts:error', function (_, data) {
                $scope.message.warning = 'Sorry.  An unknown error occured.';
                $scope.$broadcast('stopSpinner');
            });
            $scope.$on('downloadService:getEulas:success', function (_, data, callback) {
                $scope.eulas = data.reduce(function (eulas, entry) {
                    eulas[entry.AnacondaId_textS] = entry.Eula_textS;
                    return eulas;
                }, {});
                if (angular.isFunction(callback)) {
                    callback();
                }
            });
            $scope.$on('downloadService:getEulas:error', function (_, data) {
                $scope.message.warning = 'Sorry.  An unknown error occured when retrieving EULAs.';
                $scope.$broadcast('stopSpinner');
            });
            $scope.$on('downloadService:getDocuments:success', function (_, data, callback) {
                var structuredDocuments = DocumentService.splitDocuments(data, translations, $scope.selected);
                $scope.structuredDocuments = structuredDocuments;
                $scope.FormData = {
                    documents: $scope.structuredDocuments
                };

                $scope.documentConcordance = {
                    drivers: DocumentService.buildConcordance(structuredDocuments.drivers, translations, 'drivers', $scope.selected, true),
                    manuals: DocumentService.buildConcordance(structuredDocuments.manuals, translations, 'manuals', $scope.selected),
                    applications: DocumentService.buildConcordance(structuredDocuments.applications, translations, 'applications', $scope.selected, true),
                    firmware: DocumentService.buildConcordance(structuredDocuments.firmware, translations, 'firmware', $scope.selected),
                    safetyDocuments: DocumentService.buildConcordance(structuredDocuments.safetyDocuments, translations, 'safetyDocuments', $scope.selected)
                };

                $scope.oses = {};
                $scope.documents = data;

                // keep text input in sync when changing product select field
                $timeout(function () {
                    $scope.$broadcast('updateDocumentHeight');
                    jQuery('.document-type-title').on('click', function () {
                        var parent$ = $(this).parent();
                        $(this).toggleClass('open');
                        parent$.children('.anaconda-accordion-close').toggle();
                        parent$.children('.anaconda-accordion-open').toggle();
                        parent$.children('.anaconda-accordion-content').toggle();

                        $scope.$broadcast('updateDocumentHeight');
                    });
                    jQuery('.description-icon > .tooltip-icon').tooltip({
                        position:"bottom right",
                        offset:[140, 170],
                        relative:true,
                        predelay:"300",
                        effect:"slide"
                    });
                    let updateShowFired = false;
                    jQuery('.description-icon > .tooltip-icon').on('tooltip-show', function (event) {
                        if (!updateShowFired) {
                            updateShowFired = true;
                            $timeout(function () {
                                $scope.$broadcast('updateDocumentHeight');
                                updateShowFired = false;
                            }, 300);
                        }
                    })
                    let updateHideFired = false;
                    jQuery('.description-icon > .tooltip-icon').on('tooltip-hide', function (event) {
                        if (!updateHideFired) {
                            updateHideFired = true;
                            $timeout(function () {
                                $scope.$broadcast('updateDocumentHeight');
                                updateHideFired = false;
                            }, 300);
                        }
                    })
                });

                if (angular.isFunction(callback)) {
                    callback();
                }
            });
            $scope.$on('downloadService:getDocuments:error', function (_, data) {
                $scope.message.warning = 'Sorry.  An unknown error occured.';
                $scope.$broadcast('stopSpinner');
            });

        }
    ]);

    if (jQuery('#download-center').length > 0) {
        angular.bootstrap(document.querySelector('#download-center'), ['downloadCenterApp']);
    }
}());
